export class ResetPasswordRequest {

    email?: string;
  }